var canvas;

module.exports = function (svg) {
  var recalculationLimit = 5;
  canvas = INKIVE.Tool.getInstance().editor.canvas;

  while (recalculationLimit > 0 && $(svg).find('[transform]').length) {
    recalculateTransforms(svg);
    recalculationLimit--;
  }

  return svg;
};

function recalculateTransforms (svg) {
  var $transformedElements = $(svg).children('[transform]');

  _.each($transformedElements, function (el) {
    if (el.nodeName == 'path') {
      var fixedD = canvas.pathActions.convertPath(el);
      el.setAttribute('d', fixedD);
    }

    svgedit.recalculate.recalculateDimensions(el);
  });

  _.each($(svg).children(), recalculateTransforms);
}
